import React from 'react';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import { formatCurrency } from '../../format/Currency';

type ResolvedTotals = {
  messagingBalance: number;
  audioVideoBalance: number;
  contactCount: number;
  inmateCount: number;
  totalInmateCount: number;
  facilityCount: number;
  alreadyMergedCount: number;
};

type SummaryCardProps = {
  resolvedTotals: ResolvedTotals;
};

const SummaryCard: React.FC<SummaryCardProps> = ({ resolvedTotals }) => {
  return (
    <Card className="mb-3">
      <Card.Header>
        <strong>Summary</strong>
      </Card.Header>
      <Card.Body>
        <Table striped bordered size="sm">
          <tbody>
            <tr>
              <td><strong>Total Matching Inmates</strong></td>
              <td>{resolvedTotals.totalInmateCount}</td>
            </tr>
            <tr>
              <td><strong>Inmates to be Merged</strong></td>
              <td>{resolvedTotals.inmateCount}</td>
            </tr>
            {resolvedTotals.alreadyMergedCount > 0 && (
              <tr>
                <td><strong>Already Merged</strong></td>
                <td>{resolvedTotals.alreadyMergedCount}</td>
              </tr>
            )}
            <tr>
              <td><strong>Facilities</strong></td>
              <td>{resolvedTotals.facilityCount}</td>
            </tr>
            <tr>
              <td colSpan={2} className="bg-light">
                <strong>Totals from Inmates to be Merged:</strong>
              </td>
            </tr>
            <tr>
              <td style={{ paddingLeft: '2rem' }}><strong>Messaging Balance</strong></td>
              <td>{formatCurrency(resolvedTotals.messagingBalance * -1)}</td>
            </tr>
            <tr>
              <td style={{ paddingLeft: '2rem' }}><strong>Audio/Video Balance</strong></td>
              <td>{formatCurrency(resolvedTotals.audioVideoBalance * -1)}</td>
            </tr>
            <tr>
              <td style={{ paddingLeft: '2rem' }}><strong>Contacts</strong></td>
              <td>{resolvedTotals.contactCount}</td>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default SummaryCard;
